import { Component } from '@angular/core';

@Component({
  selector: 'app-cylinder-icon',
  templateUrl: './cylinder-icon.component.svg',
  styleUrls: ['./cylinder-icon.component.scss']
})
export class CylinderIconComponent
{
  constructor() { }
}
